import {
    get,
    post
} from './../http.js'
import router from '../../src/router'
import {
    Toast
} from 'vant';

/**
 * type 1  预防性维护   2 巡检     3保养
 * JHDH   **
 * Code   SBBH(或KSBH)
 * Genre  Y or N (未执行还是已执行)
 * SSDH   实施单号(仅已执行存在)
 * UrlName 跳转页面名称
 * UrlParams  跳转页面所需参数
 * ***/
export function ExistsEdorIng(type, Genre, UrlName, item) {
    get('api/YF/ExistsEdorIng', {
        type: type,
        JHDH: item.OrderNo || item.JHDH,
        Code: item.EquId || item.KSBH,
        Genre: Genre,
        SSDH: item.SSDH ? item.SSDH : ' '
    }).then(result => {
        if (result.Status) {
            router.push({
                name: UrlName,
                params: {
                    item
                }
            });
        } else {
            Genre === 'Y' ? Toast(result.Msg) : router.push({
                name: UrlName,
                params: {
                    item,
                    ButtonExists: true
                }
            });
        }
    })
}

/**多级审批   提交方法
 * 传入前封装好item
 * */
export function ApplyResult(item) {
    post('api/Audit/MultistageAuditSubmit', {
        TYPE: item.TYPE,
        SQDH: item.SQDH,
        JCBH: item.JCBH,
        jCHH: item.JCHH,
        SQR: item.SQR,
        SHRQ: item.SHRQ,
        SPYJ: item.SPYJ,
        STORE: item.STORE,
        SBBH: item.SBBH,
        YJYY: item.YJYY,
        BFJY: item.BFJY,
        GKHM: item.GKHM,
        SFTG: item.SFTG,
        SPLX: item.SPLX,
    }).then(result => {
        if (result.Status) {
            Toast('审批成功!');
            setTimeout(x => {
                router.back();
            }, 1000)
        } else Toast('审批失败,请稍后再试!');
    })
}

//根据系统参数获取系统设定值
export function GetSystemParameter() {
    get('api/Property/GetSystemParameter', {
        SystemName: 'DepartmentConfirmMaintenance'
    }).then(result => {
        router.push({
            name: 'ServiceList',
            params: {
                SystemValue: result
            }
        });
    })
}

//保养 质量控制 从消息到计划获取基本数据
//PlanType: 1、保养 2、预防 3、巡检
export function MessageToPlanGetDefault(PlanType, JHDH, SBBH, TabIndex) {
    get('api/YF/MessageToPlanGetDefault', {
        PlanType: PlanType,
        JHDH: JHDH,
        SBBH: SBBH,
        TabIndex: TabIndex
    }).then(result => {
        try {
            result = JSON.parse(result);
            if (result.length > 0) {
                TabIndex == "2" ? result[0].SSDH = JHDH : '';
                PlanType == "1" ? //state阻止循环
                    router.push({
                        name: 'MaintainImplementDefault',//跳转保养
                        params: {
                            item: result[0],
                            state: true,
                            ButtonExists: TabIndex == "2"
                        }
                    }) :PlanType == "2"?//跳转预防
                    router.push({
                        name: 'QualityTest',
                        params: {
                            item: result[0],
                            state: true,
                            ButtonExists: TabIndex == "2"
                        }
                    }):router.push({    //跳转巡检
                        name: 'PollingimplementDefault_XS',
                        params: {
                            item: result[0],
                            state: true,
                            ButtonExists: TabIndex == "2"
                        }
                    })
            }
        } catch (e) {
            Toast('数据异常,请联系管理员!');
        }
    })
}

//保养 质量 从消息跳转验收
export function MessageToCheckAndAccept(PlanType, SSDH, KSBH) {
    if (PlanType === 15) {
        router.push({
            name: 'PrecautionreceivingDefault',
            params: {
                item: {
                    SSDH: SSDH,
                    SBBH: KSBH, //此处SBBH代指巡检科室编号
                },
                state: true,
                Title: '巡检验收',
                pageState: 2
            }
        });
        return false;
    }
    get('api/YF/MessageToCheckAndAccept', {
        PlanType: PlanType,
        SSDH: SSDH
    }).then(result => {
        try {
            result = JSON.parse(result);
            if (result.length > 0) { //state阻止循环
                PlanType === 11 ? router.push({
                        name: 'PrecautionreceivingDefault',
                        params: {
                            item: result[0],
                            state: true,
                            Title: '保养验收',
                            pageState: 3
                        }
                    }) :
                    router.push({
                        name: 'PrecautionreceivingDefault',
                        params: {
                            item: result[0],
                            state: true,
                            Title: '预防验收',
                            pageState: 1
                        }
                    })
            }
        } catch (e) {
            Toast('数据异常,请联系管理员!');
        }
    })
}



//////////////////
// WEBPACK FOOTER
// ./tool/api/api.js
// module id = null
// module chunks = 